import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import InsuranceComHOService from "services/Setup/InsuranceSettingManagement/InsuranceComHOService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  loadingGetInsurance: false,
  loadingKataCalculate: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  InsuranceComHOList: [],
  InsuranceComBranchList: [],
  ApkLoanInsuranceKTAList: {},
  ApkLoanInsuranceKTAListCalculate: {},
  refreshList: false,
  InsuranceComHOApprovalList: {},
  konsumendariProspect: {},
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const getInsuranceComHO = createAsyncThunk(
  "InsuranceComHO/getInsuranceComHO",
  async (userInput, { rejectWithValue }) => { 
    try {
      const response = await InsuranceComHOService.getInsuranceComHO(userInput);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getInsuranceComBranch = createAsyncThunk(
  "InsuranceComHO/getInsuranceComBranch",
  async (userInput, { rejectWithValue }) => { 

    try {
      const response = await InsuranceComHOService.getInsuranceComBranch(
        userInput
      );
      console.log(
        "🚀 ~ file: InsuranceComHOSlice.js ~ line 85 ~ response",
        response
      );

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getApkLoanInsuranceKTA = createAsyncThunk(
  "InsuranceComHO/getApkLoanInsuranceKTA",
  async (userInput, { rejectWithValue }) => { 

    try {
      const response = await InsuranceComHOService.GetApkLoanInsuranceKTA(
        userInput
      );

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const GetApkLoanInsuranceKTACalculate = createAsyncThunk(
  "InsuranceComHO/GetApkLoanInsuranceKTACalculate",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await InsuranceComHOService.GetApkLoanInsuranceKTACalculate(userInput);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      // console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getKonsumendariProspect = createAsyncThunk(
  "InsuranceComHO/getKonsumendariProspect",
  async (data, { rejectWithValue }) => {
    try {
      const response = await InsuranceComHOService.GetKonsumendariProspect(
        data
      );

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postApkLoanInsuranceKTA = createAsyncThunk(
  "InsuranceComHO/postApkLoanInsuranceKTA",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await InsuranceComHOService.postApkLoanInsuranceKTA(
        userInput
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putApkLoanInsuranceKTA = createAsyncThunk(
  "InsuranceComHO/putApkLoanInsuranceKTA",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await InsuranceComHOService.putApkLoanInsuranceKTA(
        userInput
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteApkLoanInsuranceKTA = createAsyncThunk(
  "InsuranceComHO/deleteApkLoanInsuranceKTA",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await InsuranceComHOService.deleteApkLoanInsuranceKTA(
        userInput
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const InsuranceComHOSlice = createSlice({
  name: "InsuranceComHO",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    setNullApkLoanInsuranceKTAListCalculate: (state) => {
      state.ApkLoanInsuranceKTAListCalculate = [];
    },
    resetDataInsuranceComHO: (state) => {
      state.InsuranceComHOList = [];
      state.InsuranceComBranchList = [];
      state.ApkLoanInsuranceKTAList = {};
      state.ApkLoanInsuranceKTAListCalculate = {};
      state.refreshList = false;
      state.InsuranceComHOApprovalList = {};
      state.konsumendariProspect = {};
      state.getPageSize = "";
      state.getPageIndex = "";
      state.getCount = "";
    },
  },

  extraReducers: (builder) => {
    builder

      //list
      .addCase(getInsuranceComHO.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getInsuranceComHO.fulfilled, (state, action) => {
        state.loading = false;
        state.InsuranceComHOList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getInsuranceComHO.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //getInsuranceComBranch
      .addCase(getInsuranceComBranch.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getInsuranceComBranch.fulfilled, (state, action) => {
        state.loading = false;
        state.InsuranceComBranchList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getInsuranceComBranch.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //getInsuranceComBranch
      .addCase(getApkLoanInsuranceKTA.pending, (state) => {
        state.loadingGetInsurance = true;
        state.redirect = "";
      })
      .addCase(getApkLoanInsuranceKTA.fulfilled, (state, action) => {
        state.loadingGetInsurance = false;
        state.ApkLoanInsuranceKTAList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getApkLoanInsuranceKTA.rejected, (state, action) => {
        state.loadingGetInsurance = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //getInsuranceComBranch
      .addCase(GetApkLoanInsuranceKTACalculate.pending, (state) => {
        state.loadingKataCalculate = true;
        state.redirect = "";
        state.ApkLoanInsuranceKTAListCalculate = [];
      })
      .addCase(GetApkLoanInsuranceKTACalculate.fulfilled, (state, action) => {
        console.log("🚀 ~ file: InsuranceComHOSlice.js:421 ~ action:", action);
        
        state.loadingKataCalculate = false;
        state.ApkLoanInsuranceKTAListCalculate = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(GetApkLoanInsuranceKTACalculate.rejected, (state, action) => {
        state.loadingKataCalculate = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //getKonsumendariProspect
      .addCase(getKonsumendariProspect.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getKonsumendariProspect.fulfilled, (state, action) => {
        state.loading = false;
        state.konsumendariProspect = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getKonsumendariProspect.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //   post
      .addCase(postApkLoanInsuranceKTA.pending, (state) => {
        state.loadingGetInsurance = true;
      })
      .addCase(postApkLoanInsuranceKTA.fulfilled, (state, action) => {
        state.loadingGetInsurance = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(postApkLoanInsuranceKTA.rejected, (state, action) => {
        state.loadingGetInsurance = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //  delete
      .addCase(deleteApkLoanInsuranceKTA.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteApkLoanInsuranceKTA.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(deleteApkLoanInsuranceKTA.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   put
      .addCase(putApkLoanInsuranceKTA.pending, (state) => {
        state.loading = true;
      })
      .addCase(putApkLoanInsuranceKTA.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(putApkLoanInsuranceKTA.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
  setNullApkLoanInsuranceKTAListCalculate,
  resetDataInsuranceComHO,
} = InsuranceComHOSlice.actions;

export default InsuranceComHOSlice.reducer;
